import React from 'react';
import TextField from '@material-ui/core/TextField';

import { TypeCameraIcon } from '../../../images/icons/WrapSvg';
import FileBase64 from '../../inputs/Logo';
import Loading from '../../dialogs/loading';
import BlueButton from '../../buttons/BlueButton';
import Back from './backstep';

class Client extends React.Component {

    state = {
        isLoading: false
    }

    handleErrorUpload = (error) => {
        this.setState({ isLoading: false, error: error });
    }

    isLoading() {
        this.setState({ isLoading: true });
    }

    async getFiles(file) {
        this.setState({ isLoading: false });
        this.props.onSave('logo', file);
    }

    render() {
        const { isLoading } = this.state;
        const { intl, onboarding } = this.props;
        const { logo, nombre } = onboarding;
        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    <div className="ob_welcome">
                        {isLoading && <Loading open opacity />}
                        <TextField
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            required
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className={'flex_full_row margin_bottom_24'}
                            value={nombre ? nombre : ''}
                            onChange={(e) => this.props.onSave('nombre', e.target.value)}
                            margin="normal"
                        />
                        <div className="flex_auto_row center ob_cliente_logo_title">
                            {intl.formatMessage({ id: 'ob_cliente_logo_title' })}
                        </div>
                        <div className="ob_upload margin_top_9 center">
                            {logo
                                ? <div className="flex_auto_row ob_upload_bt bg_white padding_borders_flat">
                                    <img
                                        src={logo}
                                        width={250}
                                        alt="Preview"
                                    />
                                </div>
                                : <button className="ob_upload_bt">
                                    <TypeCameraIcon width={16} heigth={16} color={'primary'} />
                                </button>
                            }
                            <FileBase64
                                multiple={true}
                                onStart={this.isLoading.bind(this)}
                                onDone={this.getFiles.bind(this)}
                                onError={this.handleErrorUpload.bind(this)}
                            />
                        </div>
                        <div className="flex_auto_row center ob_cliente_logo_subtitle">
                            {intl.formatMessage({ id: 'ob_cliente_logo_subtitle' })}
                        </div>
                    </div>
                </div>
                <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                    <BlueButton id="next" className="ob_next" onClick={this.props.onNext} />
                </div>
            </div>
        );
    }
}

export default Client;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/client.js